/**
 * Created by zjy on 2017/8/7.
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const store = new Vuex.Store({
  modules:{

  },
  state:{
    uid:"",
    sendflag:"0",
    eqObject:{},
    alert5:false,
    list1:[],
    list2:[],
    eqType:""
  },
  mutations:{

  },
  actions:{

  }
});
export default store



// WEBPACK FOOTER //
// ./src/store.js